/*
 * Force-evaluate config so the default Datadog sink registers even when consumers only
 * import core APIs (defineJourney, etc.). Paired with package.json "sideEffects" for
 * config — otherwise bundlers with sideEffects:false would drop an unused re-export.
 */
import './config';

export {
    // Preferred app API.
    defineJourney,
    // Name-string lifecycle (prefer handle methods when you own the journey).
    completeJourney,
    excludeJourney,
    failJourney,
    journeyStep,
    restoreJourney,
    serializeJourneyState,
    setJourneyTags,
    // Custom transport adapters / request attribution.
    singleInFlightJourneyStep,
    resolveStamp,
    JourneyStepStamp,
    type JourneyDef,
    type JourneyHandle,
    type JourneyNameLike,
    type JourneyStepOptions,
    type JourneyStepTarget,
    type SerializedJourneyState,
    type StepHandle,
} from './core';

export { configureJourney, type JourneyConfig } from './config';
export type { EndpointPolicy, SlowRequestConfig } from './core/endpoint-policy';
export type {
    JourneyHttpPolicyContext,
    JourneyHttpScore,
    JourneyHttpScoreContext,
    JourneyRequestPolicy,
    JourneyStampOptions,
    RequestPolicyConfig,
} from './core/request-policy';

export type { JourneySink } from './core';

export { instrumentAxios } from './integrations/axios';
export { instrumentFetch } from './integrations/fetch';
export { exposeAppJourney, instrumentJquery } from './integrations/jquery';
export { requestKey, type JourneyTimedMeta } from './integrations/request-key';
export { onHttpComplete, type HttpCompleteReport } from './integrations/http-report';
export {
    disableJourney,
    disableJourneyDebugging,
    enableJourney,
    enableJourneyDebugging,
    isJourneyDebugEnabled,
    isJourneyEnabled,
    setJourneyDefaultEnabled,
    teardownJourney,
} from './global';
export { sendToConsole } from './sinks/console';
export { normalizeTagValue, sendToDatadog, setJourneyRum } from './sinks/datadog';

export type { JourneyEvent, JourneyRequestEvent, JourneyStepEvent, TagValue } from './core';

export { useJourneyName, useOptionalJourneyName } from './integrations/react/context';
export { JourneyScope } from './integrations/react/scope';
export { useJourneyStep } from './integrations/react/use-journey-step';
